/**
 * Cmarkdownlist Component
 * List container for markdown rendering (ordered and unordered lists)
 */
'use client';
import type { ReactNode, CSSProperties } from 'react';
import { pxToRem } from '@/theme/spacing';
export interface CmarkdownlistProps {
    children: ReactNode;
    ordered?: boolean;
    depth?: number;
    className?: string;
    style?: CSSProperties;
}
export function Cmarkdownlist({ children, ordered = false, depth = 0, className, style, }: CmarkdownlistProps) {
    // Build debug prefix
    // Note: 'ordered' prop is used by parent components to style list items
    // but not directly used in this container component
    void ordered;
    const wrapperStyle: CSSProperties = {
        display: 'flex',
        flexDirection: 'column',
        gap: pxToRem(6),
        marginBottom: depth > 0 ? pxToRem(4) : 0,
        marginLeft: depth > 0 ? pxToRem(24) : 0,
        ...style,
    };
    return (
      <div className={className} style={wrapperStyle}>
        {children}
      </div>
    );
}
